import React from "react";
import "./pageContainerBase.css";

const pageContainerBase = props => {
  return <div className="page-wrapper">{props.children}</div>;
};

export default pageContainerBase;
